<div *ngIf="wrapped" class="form-group" [ngClass]="wrappedClass">
  <label for="{{name}}">{{label || (name | stringSpacer)}}:</label>
  <select id="{{name}}" class="form-control form-control-sm" name="{{name}}" [ngClass]="class" [attr.disabled]="disabled ? 'disabled' : null" [(ngModel)]="model"
    (ngModelChange)="modelChanged($event)">
    <option *ngIf="nullable" value="{{nullableValue}}"></option>
    <option *ngFor="let option of options" [ngValue]="(optionValueProperty ? option[optionValueProperty] : option)">
      {{(optionTextProperty ? option[optionTextProperty] : option)}}
    </option>
  </select>
</div>

<select *ngIf="!wrapped" id="{{name}}" class="form-control form-control-sm" name="{{name}}" [ngClass]="class" [attr.disabled]="disabled ? 'disabled' : null" [(ngModel)]="model"
  (ngModelChange)="modelChanged($event)">
  <option *ngIf="nullable" value="{{nullableValue}}"></option>
  <option *ngFor="let option of options" [ngValue]="(optionValueProperty ? option[optionValueProperty] : option)">
    {{optionTextProperty ? option[optionTextProperty] : option}}
  </option>
</select>